export default {
  save: '저장',
  cancel: '취소',
  no_results: '검색결과 없음',
}